module.exports = __webpack_public_path__ + "img/ascend_gold6.aedaddfc.png";